import ReactPlayer from 'react-player' //library for playing videos
//taking video url-image-play icon as params
function VideoPlayer({url,imageUrl,icon}) {
  return imageUrl?(<ReactPlayer url={url}  width="100%" height="100%"  playIcon={icon} playing light={imageUrl} controls={true} />):<></>
  
}

export default VideoPlayer
